//
// PositionedModelOwner.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "./PositionedModel";
import "../layoutElements/LayoutElement";

var PositionedModelOwner = createModule("BIRD::PositionedModelOwner", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel","BIRD::PositionedModel"], EventDispatcher, [
    ,
    {
        layout: 1,
        visualsAndContainers: [1],
    },
    ,
    ,
    ,
    ,
    ,
]);
export default PositionedModelOwner;
